import { render, staticRenderFns } from "./MemberUpgradeRules.vue?vue&type=template&id=fce813ca&"
import script from "./MemberUpgradeRules.vue?vue&type=script&lang=js&"
export * from "./MemberUpgradeRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports